export default function getHTMLTextContent(html: string): string {
  const node = document.createElement("div");
  node.innerHTML = html;
  return node.textContent || node.innerText;
}
